/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Workout_StartInputs */

const en_us2_workout_start = /** @type {(inputs: Workout_StartInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Start workout`)
};

const pt_br2_workout_start = /** @type {(inputs: Workout_StartInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Começar treino`)
};

const es_419_workout_start = /** @type {(inputs: Workout_StartInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Empezar entrenamiento`)
};

const pt_pt2_workout_start = /** @type {(inputs: Workout_StartInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Começar treino`)
};

const fr_fr2_workout_start = /** @type {(inputs: Workout_StartInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Commencer la séance`)
};

const de_de2_workout_start = /** @type {(inputs: Workout_StartInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Training starten`)
};

const it_it2_workout_start = /** @type {(inputs: Workout_StartInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inizia allenamento`)
};

/**
* | output |
* | --- |
* | "Start workout" |
*
* @param {Workout_StartInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const workout_start = /** @type {((inputs?: Workout_StartInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Workout_StartInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_workout_start(inputs)
	if (locale === "es-419") return es_419_workout_start(inputs)
	if (locale === "pt-PT") return pt_pt2_workout_start(inputs)
	if (locale === "fr-FR") return fr_fr2_workout_start(inputs)
	if (locale === "de-DE") return de_de2_workout_start(inputs)
	if (locale === "it-IT") return it_it2_workout_start(inputs)
	return en_us2_workout_start(inputs)
});
export { workout_start as "workout.start" }